export const ASSIGNEE_SHORTCUT_KEY = 'a';
export const LABELS_SHORTCUT_KEY = 'l';
export const COMMENT_SHORTCUT_KEY = 'm';
